import { resources as common } from '@anywayseo/tools';


const resources = {
  en: {
    ...common.en,
  },
  it: {
    ...common.it,
  },
} as const;

type DefaultResourceType = (typeof resources)['en'];

export type { DefaultResourceType };
export default resources;
